import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import {Button} from "primereact/button";
import {hasRole} from "../../../../utils/hasRole";

const ReceiptNavReportListComponent = (props) => {

  const {t} = props;
  const [receiptNavReports, setReceiptNavReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const [refreshingId, setRefreshingId] = useState(null);
  const requestVersion = useRef(0);
  const loadLazyData = () => {
    setLoading(true);
    const version = ++requestVersion.current;
      let query = window.App.transformQueryParams(lazyParams)
      return apiCall('get', '/api/v2/nav-report?search[receipt][operator]==&search[receipt][value]=' + props.receiptId + '&' + query)
        .then(response => {
          if (version !== requestVersion.current) return;
          setTotalRecords(response.data.data.total_item_count);
          setReceiptNavReports(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          if (version === requestVersion.current) setLoading(false);
        })

  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const refreshStatus = async (reportId) => {
    setRefreshingId(reportId);
    try {
      await apiCall('post', '/api/v2/nav-report/' + reportId + '/refresh');
      await loadLazyData();
    } catch (error) {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    } finally {
      setRefreshingId(null);
    }
  };

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, props.receiptId, props.navReports, window.App.state.rerenderReceiptNavReportList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={receiptNavReports} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
         <Column field="last_status" header={t('columnStatus2')} sortable
            body={(rowData) => {
              return (
                <>
                  {rowData.last_status === 'PROCESSING' &&
                  <>
                            <span className={"text-warning"}><i
                              className={"pi pi-exclamation-circle"}></i> Feldolgozás folyamatban</span>
                  </>
                  }
                  {rowData.last_status === 'RECEIVED' &&
                  <>
                            <span className={"text-warning"}><i
                              className={"pi pi-exclamation-circle"}></i> Információk átadva</span>
                  </>
                  }
                  {rowData.last_status === 'SAVED' &&
                  <>
                    <span className={"text-success"}><i className={"pi pi-check"}></i> Információk rögzítve</span>
                  </>
                  }
                  {rowData.last_status === 'ABORTED' &&
                  <>
                    <span className={"text-danger"}><i
                      className={"pi pi-times"}></i> Megszakítva</span>
                  </>
                  }
                  {rowData.last_status === 'DONE' &&
                  <>
                            <span className={"text-success"}><i
                              className={"pi pi-check"}></i> Sikeres</span>
                  </>
                  }
                  {!rowData.last_status &&
                  <>
                    <span><i className={"pi pi-times"}></i> Nincs adat</span>
                    {hasRole('ROLE_NAV_SYNC') && rowData.transaction_id &&
                      <Button type="button" label="Státusz frissítése" icon="pi pi-refresh"
                              className="p-button-text p-button-sm p-ml-2"
                              loading={refreshingId === rowData.id} disabled={refreshingId !== null}
                              onClick={() => refreshStatus(rowData.id)} />
                    }
                  </>
                  }
                  {rowData.last_status_message !== null &&
                  <>
                    <br/>
                    <small style={{
                      fontSize: '10px',
                      wordWrap: 'break-word',
                      display: 'block',
                      maxWidth: '220px'
                    }}>{rowData.last_status_message}</small>
                  </>
                  }
                </>
              )
            }}
    />
    <Column field="type" header={t('columnType')} sortable
            body={(rowData) => {
              return (
                <>
                  {rowData.type === 'CREATE' &&
                  <>
                    Kiállított számla
                  </>
                  }
                  {rowData.type === 'STORNO' &&
                  <>
                    {t('stornoInvoice')}
                  </>
                  }
                  {rowData.type === 'MODIFY' &&
                  <>
                    Módosító számla
                  </>
                  }
                  {rowData.type === 'ANNULMENT' &&
                  <>
                    Technikai érvénytelenítés
                  </>
                  }
                </>
              )
            }}></Column>
    <Column field="transaction_id" header={t('columnIdentifier')}
            ></Column>
    <Column field="report_date" header={t('columnDateAndTime')} className={"p-text-nowrap"}
            body={(rowData) => {
              return (
                <>{rowData.report_date ? new Date(rowData.report_date).toLocaleString('hu-HU') : ''}</>
              )
            }}></Column>
        {/* <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> */}
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ReceiptNavReportListComponent);
